export default "__VITE_ASSET__c3ce321b__"